<template>
  <div
    :class="`formulate-input-element formulate-input-element--select`"
    :data-type="context.type"
	autocomplete="off"
  >
    <div class="input-select">
		<v-select 
			v-bind="context.attributes"
			autocomplete="none"
			:options="context.options" 
			:placeholder="(context.attributes.placeholder) ? context.attributes.placeholder : 'Buscar cliente'"
			@search="search"
			v-model="formatted"
			label="id"
			:filterable="false"
			:clearable="false"
			>
			<template #selected-option="option">
				<div style="display: flex; align-items: baseline;">
					<strong>{{ option.name }} {{ option.lastname }}</strong>
					<em style="margin-left: .5rem;">{{ option.email }}</em>
				</div>
			</template>
			<template #list-header>
				<div class="create-new" @click="$emit('create')">
					<i class="icon icon-plus mr-2"></i> {{context.attributes.createButtonText}}
				</div>
			</template>
			<template #no-options>
				<div></div>
			</template>

			<template #option="option" >
				<div class="item">
					<strong>{{ option.name }} {{ option.lastname }}</strong><br>
					<em>{{ option.email }}</em>
				</div>
			</template>
		</v-select>

    </div>
  </div>
</template>

<script>
// import { ModelListSelect  } from "vue-search-select";
import 'vue-select/dist/vue-select.css';

export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  components: {
    // ModelListSelect,
  },
	data() {
		return {
		}
	},
	computed: {
		formatted: {
			get: function() {
				return this.context.model;
			},
			set: function(newValue) {
				console.log(newValue)
				this.context.model = newValue;
			},
		},
	},
	methods:{
		search(data){
			this.$emit('search', data)
		}
	}
};
</script>

<style scoped>
.input-select /deep/ .vs__search{
	border:none !important;
}
.v-select input{
	/* border:none !important; */
}
</style>
